<template lang="pug" src="./dashboard.pug"></template>
<script>
export default{
  data(){
    return{
      items: ['até 10m', '11 a 30m', '31m a 2h']
    }
  }
}
</script>
<style scoped>
  .info01{ color: #00CD69 }
  .info02{ color: #1AE2A9 }
  .info03{ color: #089AFE }
  .info04{ color: #36C9FE }
  .info05{ color: #FCC71A }
  .info06{ color: #FFDA7F }
  .info07{ color: #798790 }
  .info08{ color: #1C3841 }
</style>
